<template>
  <v-card>
    <v-card-title class="blue-grey lighten-5 primary--text">
      {{ tTemperatureTitle }}
    </v-card-title>

    <v-form ref="post_temperature_form">

      <v-card-text class="py-3">

        <time-picker
          v-model="recordedAt"
          :label="tTemperatureTime"
          prepend-icon="mdi-clock-time-four-outline"
          :rules="[rules.required]"
          outlined
          dense
        />

        <div class="d-flex align-baseline">
          <v-select
            color="primary"
            base-color="primary"
            v-model="temperature"
            :items="options"
            item-title="text"
            item-value="value"
            :rules="[rules.required]"
            :label="tTemperatureValue"
            variant="outlined"
            density="compact"
            :menu-props="{ auto: true }"
          ></v-select>
          <!-- <p class="ml-1 body-1">℃</p> -->
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="close"
          color="error"
          text
        >
          {{ tCancel }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="clickPost"
          :loading="btnLoading"
          color="primary"
          variant="flat"
        >
          {{ tSubmit }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

    </v-form>

  </v-card>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import { t } from '@/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import rules from '@/service/ValidRules';

import TimePicker from '@/components/molecules/TimePicker.vue';
import { dailyReportModule } from '@/store/entityModules/dailyReport';

// model
import { VForm } from '@/model/Vuetify/VForm';

interface DataType {
  recordedAt: string;
  temperature: number | null;
  btnLoading: boolean;
  isRecordetAtPicker: boolean;
}

export default defineComponent({
  name: 'TemperatureModal',
  components: {
    TimePicker,
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    childId: {
      type: Number,
      default: NaN,
    },
    selectedDate: {
      type: String,
      default: dayjs().format('YYYY-MM-DD'),
    },
  },

  computed: {
    tTemperatureTitle(): string {
      return t('record.modal.temperatureTitle', '体温');
    },
    tTemperatureTime(): string {
      return t('record.modal.temperatureTime', '時間');
    },
    tTemperatureValue(): string {
      return t('record.modal.temperatureValue', '体温');
    },
    tCancel(): string {
      return t('common.cancel', 'キャンセル');
    },
    tSubmit(): string {
      return t('common.submit', '送信');
    },
    rules() {
      return rules;
    },
    form(): VForm {
      return (this.$refs as any).post_temperature_form;
    },
    options() {
      const options: Array<{text: string, value: number}> = [];
      for (let i = 340; i < 430; i++) {
        options.push({
          text: `${(i / 10).toFixed(1)}℃`,
          value: parseFloat((i / 10).toFixed(1)),
        });
      }
      return options;
    },
  },

  watch: {
    isOpen: {
      handler(val: boolean) {
        if (val) {
          this.temperature = null;
          this.recordedAt = dayjs().format('HH:00');
        }
      },
      deep: true,
    },
  },

  data: (): DataType =>({
    recordedAt: dayjs().format('HH:00'),
    temperature: 36.5,
    btnLoading: false,
    isRecordetAtPicker: false,
  }),

  methods: {
    allowedStep: (m) => m % 5 === 0,
    close() {
      this.$emit('close');
    },
    async clickPost() {
      if (this.form.validate() && this.temperature) {
        this.btnLoading = true;
        try {
          const recordedAtHour = this.recordedAt.split(':')[0];
          const recordedAtMinutes = this.recordedAt.split(':')[1];
          const recordedAtTime = dayjs().hour(Number(recordedAtHour)).minute(Number(recordedAtMinutes));
          await dailyReportModule.postTemperature({
            childId: this.childId,
            date: this.selectedDate,
            recordedAt: dayjs(recordedAtTime).toISOString(),
            temperature: this.temperature,
          });
          this.$emit('posted');
          this.$emit('close');
          this.btnLoading = false;
        } catch (error) {
          this.$emit('close');
          this.btnLoading = false;
        }
      }
    },
  },
});
</script>
<style lang="scss" scoped>
</style>
